import {BuildUrlProps} from './types';

function buildUrl({url, params}: BuildUrlProps) {
	return `${url}?${params}`;
}

export {buildUrl};
